const settingsPageTradeSectionCopy = {
  error: 'Your OTC settings were not saved.',
  title: 'Trade Settings',
  success: 'Your Trade settings have been updated.',
};

export default settingsPageTradeSectionCopy;
